/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Isprivatpflegeversichert2Inputs */



/**

* @param {_Field_Isprivatpflegeversichert2Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_isprivatpflegeversichert2 = /** @type {((inputs?: _Field_Isprivatpflegeversichert2Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Isprivatpflegeversichert2Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Privat pflegeversichert")
});
export { _field_isprivatpflegeversichert2 as "_field_isPrivatPflegeversichert" }